// extracted by mini-css-extract-plugin
export default {"floor":"PropertyType_floor__0mWob","tabsContainer":"PropertyType_tabsContainer__9R0Kf","tabItem":"PropertyType_tabItem__Rnba4"};